import { ARIAS } from '../../utils/constants';

const DEFAULT_ARTICLES_SELECTOR = '[data-blog-articles]';
const PAGINATION_SELECTOR = '[data-pagination]';

const initBlogPagination = (articlesSelector = DEFAULT_ARTICLES_SELECTOR) => {
  const paginationEl = document.querySelector(PAGINATION_SELECTOR);
  const articlesEl = document.querySelector(articlesSelector);
  
  if (!paginationEl || !articlesEl) return;
  
  const sectionId = paginationEl.dataset.sectionId;

  const fetchPage = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch page: ${response.status}`);
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    } catch (err) {
      console.error('Error fetching blog articles:', err);
    }
  };

  const getSectionUrl = (url) => {
    const sectionUrl = new URL(url, window.location.origin);
    if (sectionId) {
      sectionUrl.searchParams.set('section_id', sectionId);
    }
    return sectionUrl.href;
  };

  const loadMoreArticles = async (url, linkEl) => {
    try {
      linkEl.setAttribute(ARIAS.BUSY, 'true');
      linkEl.setAttribute(ARIAS.DISABLED, 'true');

      const doc = await fetchPage(getSectionUrl(url));
      const newArticlesEl = doc?.querySelector(articlesSelector);
      const newPaginationEl = doc?.querySelector(PAGINATION_SELECTOR);

      if (!articlesEl || !newArticlesEl || !newPaginationEl) {
        linkEl.removeAttribute(ARIAS.BUSY);
        linkEl.removeAttribute(ARIAS.DISABLED);
        return;
      }

      [...newArticlesEl.children].forEach(child => articlesEl.appendChild(child));
      paginationEl.innerHTML = newPaginationEl.innerHTML;
    } catch (err) {
      console.error('Error loading more articles:', err);
      linkEl.removeAttribute(ARIAS.BUSY);
      linkEl.removeAttribute(ARIAS.DISABLED);
    }
  };

  paginationEl.addEventListener('click', (e) => {
    const loadMoreLink = e.target.closest('[data-load-more]');
    if (!loadMoreLink || loadMoreLink.getAttribute(ARIAS.BUSY) === 'true') return;

    e.preventDefault();
    loadMoreArticles(loadMoreLink.href, loadMoreLink);
  });
};

export default initBlogPagination;
